import React from 'react';
import Switch from 'react-switch';

export const ServicioOfrecidoEmpresaAdmin = ({
	servicio,
	setServisNumber,
	cambiarEstadoServ,
	IsDisabled,
}) => {
	return (
		<div className='servEmpresa'>
			<div className='precioServTitle'>
				<div>
					<b>{servicio.servicio_id.nombre.toUpperCase()}</b>
				</div>
				<div>
					<Switch
						onChange={() => cambiarEstadoServ(servicio.id)}
						checked={servicio.estado}
						onColor='#23C290'
						uncheckedIcon={false}
						disabled={IsDisabled}
					/>
				</div>
			</div>
			<div className='precioServ'>
				<div className='centrador'>Precio</div>
				<div>
					<input
						type='number'
						className={'servInput servInput' + servicio.estado.toString()}
						disabled={servicio.estado && IsDisabled}
						value={servicio.precioMin}
						name={'precioMin'}
						onChange={(e) => setServisNumber(e, servicio.id)}
					/>
				</div>
				<div className='centrador'>€/ hora</div>
			</div>
			<div className='precioServ'>
				<div className='centrador'>Número mínimo de horas</div>
				<div>
					<input
						type='number'
						className={'servInput servInput' + servicio.estado.toString()}
						disabled={servicio.estado && IsDisabled}
						value={servicio.horasMin}
						name={'horasMin'}
						onChange={(e) => setServisNumber(e, servicio.id)}
					/>
				</div>
			</div>
		</div>
	);
};
